import {Container, Graphics, Sprite} from 'pixi.js';
import {ReelViewData} from '@gongxigames/framework/slot/modules/reels/ReelView';
import {IndependentReelView} from '@gongxigames/framework/slot/modules/reels/IndependentReelView';

export class FirecatcherReelView extends IndependentReelView {

    protected _jpSymbol: number;

    protected _jpSymbolsParentContainer: Container;

    // we have the following layering: Symbol bg -> Symbol -> Fader -> JP Symbol
    protected _jpSymbolsContainer!: Container;

    constructor(reelData: ReelViewData, jpSymbolsContainer: Container, jpSymbol: number) {
        super(reelData);

        this._jpSymbolsParentContainer = jpSymbolsContainer;
        this._jpSymbol = jpSymbol;
    }

    public replaceSymbolAt(position: number, symbolId: number): void {
        const symbol = this._symbols[this.rowIndexToSymbolIndex(position)];

        symbol.setSymbol(symbolId);

        this.updateJPSymbolLayer(symbolId, symbol);
    }

    protected createReel(): void {
        this._backgroundContainer = new Sprite();
        this._symbolsContainer = new Container();
        this._jpSymbolsContainer = new Container();
        this._symbolsContainer.addChildAt(this._backgroundContainer, 0);
        this._container.addChild(this._symbolsContainer);
        this._jpSymbolsParentContainer.addChild(this._jpSymbolsContainer);

        const mask = this.createMask();

        this._symbolsContainer.mask = mask;
        this._jpSymbolsContainer.mask = mask;
        this._symbolsContainer.addChild(mask);

        // creating additional render-buffer of symbol from both sides of the reels
        for (let rowIndex = this._reelConstants.ROW_AMOUNT; rowIndex >= this._reelConstants.Y_ADDITIONAL_SYMBOLS_OFFSET; rowIndex--) {
            const symbol = this.createReelSymbol();
            const symbolID = this._strip[this.makeNormalizedPosition(rowIndex + this._currentPosition)];
            const background = this.getSpriteFromPool('reelsBg');

            symbol.init(this.getSpriteFromPool('symbols'));
            symbol.setSymbol(symbolID);
            symbol.index = rowIndex;
            symbol.x = this._offsets.x;
            symbol.y = this._offsets.y + this.getYPositionForRow(rowIndex);

            this._symbols[this.rowIndexToSymbolIndex(rowIndex)] = symbol;
            this.updateJPSymbolLayer(symbolID, symbol);

            if (background) {
                background.x = this._offsets.x;
                background.y = this._offsets.y + this.getYPositionForRow(rowIndex);
                this._backgroundContainer.addChild(background);
            }
        }
    }

    public setRespinGameBackground(): void {
        this.showSymbolsBackground('bg', false);
        this.showSymbolsBackground('bg_fg', false);
        this.showSymbolsBackground('bg_respin');
    }

    protected showSymbolsBackground(name: string, shouldShow = true): void {
        if (this._backgroundContainer) {
            this._backgroundContainer.children.forEach((child) => {
                const background = (child as Sprite).getChildByName(name);

                if (background) {
                    background.visible = shouldShow;
                }
            });
        }
    }

    protected createMask(): Graphics {
        const mask = new Graphics();

        mask.beginFill(0xffffff);
        mask.drawRect(0, 0, 1, 1);
        mask.endFill();
        mask.x = this._offsets.x;
        mask.y = this._offsets.y;
        mask.width = this._reelConstants.SYMBOL.width;
        mask.height = this._reelConstants.SYMBOL.height;

        return mask;
    }

    protected updateJPSymbolLayer(symbolId: number, symbol: Sprite): void {
        if (symbolId === this._jpSymbol) {
            this._jpSymbolsContainer.addChild(symbol);
        } else {
            this._symbolsContainer.addChild(symbol);
        }
    }

    protected checkAndAddScatterHitAnimation(): void {
    }
}
